// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5f-0";
export var eligibilityCardNotEligible = "_5f-1";